import React from "react";

// U-Bot mascot — white robot, dark visor, glowing violet smile, heart on chest, two antennae.
export const UBot = ({ size = 120, className = "", waving = false }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      className={className}
      role="img"
      aria-label="U-Bot mascot"
      data-testid="ubot-mascot"
    >
      <defs>
        <radialGradient id="ubotGlow" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#B9A8FF" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#7C5CFF" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="60" cy="58" r="52" fill="url(#ubotGlow)" />
      {/* antennae */}
      <line x1="44" y1="20" x2="40" y2="6" stroke="#B9A8FF" strokeWidth="3" strokeLinecap="round" />
      <line x1="76" y1="20" x2="80" y2="6" stroke="#B9A8FF" strokeWidth="3" strokeLinecap="round" />
      <circle cx="40" cy="5" r="5" fill="#7C5CFF" />
      <circle cx="80" cy="5" r="5" fill="#7C5CFF" />
      {/* head */}
      <rect x="26" y="18" width="68" height="56" rx="22" fill="#FFFFFF" stroke="#E6ECF5" strokeWidth="2" />
      {/* visor */}
      <rect x="34" y="30" width="52" height="30" rx="15" fill="#0B1F3A" />
      {/* eyes */}
      <circle cx="50" cy="43" r="4" fill="#7C5CFF" />
      <circle cx="70" cy="43" r="4" fill="#7C5CFF" />
      {/* smile */}
      <path d="M48 52 Q60 60 72 52" stroke="#7C5CFF" strokeWidth="3" fill="none" strokeLinecap="round" />
      {/* body */}
      <rect x="36" y="72" width="48" height="36" rx="16" fill="#FFFFFF" stroke="#E6ECF5" strokeWidth="2" />
      {/* heart */}
      <path d="M60 86 l-6 -6 a4 4 0 1 1 6 -5 a4 4 0 1 1 6 5 z" fill="#7C5CFF" />
      {/* arms */}
      {waving ? (
        <line x1="34" y1="80" x2="18" y2="66" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" />
      ) : (
        <line x1="34" y1="82" x2="22" y2="92" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" />
      )}
      <line x1="86" y1="82" x2="98" y2="92" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" />
    </svg>
  );
};

export default UBot;
